import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit {
  @Input() backgroundImage: string;
  @Input() fillHeight = false;
  @Input() overlayOpacity = 0;
  @Input() vimeoId;

  constructor(private sanitize: DomSanitizer) { }

  ngOnInit() {
  }

  safeStyle(style: string): SafeStyle {
    return this.sanitize.bypassSecurityTrustStyle(style);
  }

}
